exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*base-link-mixin*/\n:host /deep/ ota-dialog .dialog-wrapper-content {\n  min-height: 202px !important; }\n\n.dialog-title {\n  font-weight: bold;\n  color: #003A90; }\n\n.dialog-body {\n  margin-top: 10px;\n  font-size: 14px;\n  line-height: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cart/dialog-taxes-fees/dialog-taxes-fees.component.scss
// module id = 887
// module chunks = 22